import cx from 'classnames';
import { PROFILE_TABS_POSTS, PROFILE_TABS_PRODUCTS } from 'mk/autogenerated/translations/ProfileTabs.8e9c417dedaf384055544b4be5e88b82'
import { blogsProfileProductsUrl, blogsProfileUrl } from 'mk2/apps/blogs/urls';
import { Link } from 'mk2/components/Link';
import { url } from 'mk2/helpers/urls';
import React from 'react';
import styles from './ProfileTabs.mscss';

export enum Tab {
    POSTS,
    PRODUCTS,
}

interface OwnProps {
    className?: string;
    username: string;
    active: Tab;
    postsCount: number;
    productsCount: number;
}

type Props = OwnProps;

const ProfileTabs: React.FunctionComponent<Props> = ({ className, active, username, postsCount, productsCount }) => (
    <div className={cx(styles.ProfileTabs, className)}>
        <Link
            className={cx(styles.ProfileTabs__tab, active === Tab.POSTS && styles['ProfileTabs__tab--active'])}
            to={url(blogsProfileUrl, { username })}
        >
            {PROFILE_TABS_POSTS} {postsCount > 0 && <span className={styles.ProfileTabs__tab__count}>({postsCount})</span>}
        </Link>
        <Link
            className={cx(styles.ProfileTabs__tab, active === Tab.PRODUCTS && styles['ProfileTabs__tab--active'])}
            to={url(blogsProfileProductsUrl, { username })}
        >
            {PROFILE_TABS_PRODUCTS} {productsCount > 0 && <span className={styles.ProfileTabs__tab__count}>({productsCount})</span>}
        </Link>
    </div>
);

ProfileTabs.displayName = 'ProfileTabs';

export default React.memo<Props>(ProfileTabs);
